import { HttpTimeoutError } from '@cian/peperrors/shared';
import { hintQuestionsReceived } from 'shared/actions/chat';
import { ResponseError } from 'shared/errors/responseError';
import { IGetChatHintsByOfferResponseSchema } from 'shared/repositories/chats/entities/chat_hint/GetChatHintsByOfferResponseSchema';
import {
  EQueryParameters as EDealType,
  EQueryParameters_1 as EOfferCategory,
  EQueryParameters_2 as EOfferType,
  fetchChatMessagesHintsByOffer,
  TChatMessagesHintsByOfferResponse,
} from 'shared/repositories/chats/v1/chat-messages-hints-by-offer';

import { IThunkActionCreator } from '../../store';

export function getHintQuestions(): IThunkActionCreator {
  return async (dispatch, getState, { httpApi, logger, telemetry }): Promise<void> => {
    const state = getState();

    const {
      offer: { dealType, category, offerType },
    } = state.offerData;

    try {
      const { response, statusCode }: TChatMessagesHintsByOfferResponse = await fetchChatMessagesHintsByOffer({
        httpApi,
        parameters: {
          dealType: dealType as EDealType,
          offerCategory: category as EOfferCategory,
          offerType: offerType as EOfferType,
          shortHints: true,
        },
      });

      if (statusCode !== 200) {
        throw new ResponseError({
          domain: 'src/shared/services/chats/getHintQuestions.ts#getHintQuestions',
          message: response.message || 'Неизвестная ошибка',
          details: {
            error: JSON.stringify(response.errors),
          },
        });
      }

      dispatch(hintQuestionsReceived((response as IGetChatHintsByOfferResponseSchema).chatHints || []));
    } catch (error) {
      if (HttpTimeoutError.is(error)) {
        telemetry.increment('chats_timeout_hint_questions');
      }

      dispatch(hintQuestionsReceived([]));

      logger.warning(error, {
        degradation: 'Не удалось получить список подсказок для чата',
      });
    }
  };
}
